var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-skeleton-loader",
    {
      staticClass: "dashboard-component",
      attrs: {
        transition: "scale-transition",
        type: "image",
        "min-height": "100",
        height: "150",
        loading: _vm.isLoading
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pull-up", attrs: { "min-height": "100" } },
        [
          _c(
            "v-card-title",
            { staticClass: "overline pb-6 d-flex justify-start" },
            [_c("h3", [_vm._v("% de Tickets por tipo en el último mes")])]
          ),
          _c("v-card-text", [
            _vm.customerTicketTypes.length
              ? _c(
                  "div",
                  _vm._l(_vm.customerTicketTypes, function(customerTicketType) {
                    return _c(
                      "v-container",
                      {
                        key: customerTicketType.ticketType,
                        staticClass: "ticket-type-item ma-0 pa-0",
                        attrs: { fluid: "" }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { left: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-row",
                                        _vm._g(
                                          {
                                            staticClass:
                                              "overline mb-1 overline",
                                            attrs: {
                                              align: "stretch",
                                              justify: "end",
                                              "no-gutters": ""
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-col", [
                                            _vm._v(
                                              _vm._s(
                                                customerTicketType.ticketType
                                              )
                                            )
                                          ]),
                                          _c("v-spacer"),
                                          _c(
                                            "v-col",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    (
                                                      (customerTicketType.total *
                                                        100) /
                                                      _vm.totalTicketsInTicketTypes
                                                    )
                                                      .toFixed(2)
                                                      .replace(".", ",")
                                                  ) +
                                                  "% "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "mb-4",
                                          attrs: { dense: "", "no-gutters": "" }
                                        },
                                        [
                                          _c("v-progress-linear", {
                                            attrs: {
                                              value: (
                                                (customerTicketType.total *
                                                  100) /
                                                _vm.totalTicketsInTicketTypes
                                              ).toFixed(2),
                                              "background-color": "#94CA4E",
                                              "background-opacity": "0.2",
                                              rounded: "",
                                              height: "7",
                                              color: "#60BB46"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(customerTicketType.ticketType))
                            ]),
                            _vm._v(": "),
                            _c("span", [
                              _vm._v(_vm._s(customerTicketType.total))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }